import { Injectable } from '@angular/core';
import { SignInJwtService } from '../signIn-jwt/signIn-jwt.service';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable()
export class CoreService {
  constructor(private signInJwtService: SignInJwtService, private router: Router, private route: ActivatedRoute) {}
}
